export default "__VITE_ASSET__BYN7aFgB__"